import { nextTick } from 'vue';

export const useInternalChatMessageFocus = viewport => {
  const focusMessage = id => {
    const element = viewport.value?.querySelector(`[data-message-id="${id}"]`);
    element?.scrollIntoView({ block: 'center' });
    element?.focus({ preventScroll: true });
  };
  const preserveHistory = async (action, current) => {
    const container = viewport.value;
    const top = container?.getBoundingClientRect().top;
    const visible =
      container &&
      [...container.querySelectorAll('[data-message-id]')].find(
        element => element.getBoundingClientRect().bottom > top
      );
    const offset = visible?.getBoundingClientRect().top;
    const focused = document.activeElement;
    await action();
    await nextTick();
    if (!current() || viewport.value !== container) return;
    const anchor = container?.querySelector(
      `[data-message-id="${visible?.dataset.messageId}"]`
    );
    if (anchor)
      container.scrollTop += anchor.getBoundingClientRect().top - offset;
    if (focused?.isConnected) focused.focus({ preventScroll: true });
  };
  return { focusMessage, preserveHistory };
};
